export default "/assets/images/mila-feed-12.mp4?5fa47a79afe8de89e4f09527bfac5b1f";